import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, } from "react-bootstrap";

import "react-phone-input-2/lib/style.css";
// css
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";

import LoadingIndicator from "components/shared/LoadingIndicator";
import { errorMessageToast, formatString, successMessageToast, userFullName } from "helpers/common";
import moment from "moment";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { MANAGE_USERS_EDIT, MANAGE_USERS_LIST } from "config/paths";
import { useGetUserDetailsQuery, useSubAdminAsCollaboratorMutation, useUpdateUserPermissionMutation } from "store/services/users/role";
import { CommonToolTip, NoRecordFound } from "components/Common/Common";
import { PERMISION_TITLE } from "config/constants";
import { cloneDeep, groupBy } from "lodash";
import { EditIcon } from "Assets/icons";
import confirmDialogV2 from "utils/confirmationDialogV2";

const ManageUserDetails = () => {

    const { id: userId } = useParams();
    const navigate = useNavigate();

    const [userPermissions, setUserPermissions] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    const { data: userDetails, isLoading, isFetching } = useGetUserDetailsQuery(userId);
    const [updatePermission, { isLoading: updatePermissionLoading }] = useUpdateUserPermissionMutation();
    const [updateCollaborator, { isLoading: updateCollaboratorLoading }] = useSubAdminAsCollaboratorMutation();

    const statusOptions = [
        {
            label: "Active",
            value: "active"
        },
        {
            label: "Archived",
            value: "archived"
        },
        {
            label: "Blocked",
            value: "blocked"
        }
    ];

    const handleCheck = (id, value) => {
        const list = cloneDeep(selectedPermissions);

        const record = list?.find(x => x.module_id == id);
        const payload = { moduleId: id, userId }

        if (record) {
            const index = record?.module_permissions?.indexOf(value);
            index > -1 ? delete record?.module_permissions[index] : record?.module_permissions?.push(value)
            record.module_permissions = record?.module_permissions?.filter(Boolean);
            payload.data = { module_permissions: record.module_permissions }
        }
        else {
            list.push({ module_id: id, module_permissions: [value] });
            payload.data = { module_permissions: [value] }
        }

        setSelectedPermissions(list);
        handleSubmit(payload);
    };

    const handleCheckAll = (item, checked) => {
        const id = item?.id
        const list = cloneDeep(selectedPermissions);

        const record = list?.find(x => x.module_id == id);
        const payload = { moduleId: id, userId }

        if (record) {
            record.module_permissions = checked ? item?.module_permissions : [];
            payload.data = { module_permissions: record.module_permissions }
        }
        else {
            list.push({ module_id: id, module_permissions: item?.module_permissions });
            payload.data = { module_permissions: item?.module_permissions }
        }

        setSelectedPermissions(list);
        handleSubmit(payload);
    };

    const handleSubmit = async (payload) => {
        try {
            const result = await updatePermission(payload);
            if (result?.error) {
                errorMessageToast(result?.error, { toastId: "error" });
                return;
            };

            successMessageToast(result?.data?.message, { toastId: "success" });

        } catch (err) { console.log("Error updateing permissions") };
    };

    const handleUpdateCollaborator = async (e) => {
        const isConfirm = await confirmDialogV2({
            title: "SUB ADMIN AS COLLABORATOR ?",
            message: userDetails?.colloborators_on_notes ? "Are you sure you want to remove this sub-admin as a collaborator?" : "Are you sure you want to make this sub-admin a collaborator?"
        });
        if (!isConfirm) {
            return;
        }
        const data = {
            "colloborators_on_notes": userDetails?.colloborators_on_notes ? false : true
        }
        try {
            await updateCollaborator({ id: userId, data }).unwrap();
        } catch (error) {
            console.error("Failed to update collaborator status: ", error);
        }
    }

    useEffect(() => {

        if (userDetails?.client_role?.roleModules?.length) setUserPermissions(userDetails?.client_role?.roleModules)
        if (userDetails?.userPermissions?.length) setSelectedPermissions(userDetails?.userPermissions)

    }, [userDetails]);

    return (
        <>
            <section className=" position-relative">
                {isLoading ? <LoadingIndicator /> : <Container fluid={true}>

                    <Row style={{ borderBottom: "1px solid #dee2e6" }}>
                        {(isFetching || updatePermissionLoading || updateCollaboratorLoading) && <LoadingOverlay />}
                        <Col lg="12" className="my-3">
                            <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                                <div className="left">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                                        <li className="">
                                            <Link
                                                className="themeBlue fw-sbold back-to-btn"
                                                to={MANAGE_USERS_LIST}
                                            >
                                                <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                                                </svg> Back
                                            </Link>
                                        </li>
                                        <li className="">
                                            <Link
                                                className="themeBlue fw-sbold"
                                                style={{ textDecoration: "underline" }}
                                                to={MANAGE_USERS_LIST}
                                            >
                                                Manage Users
                                            </Link>
                                        </li>
                                        <li className="">
                                            <h5 className="m-0 fw-bold themeBlue">
                                                /  Details
                                            </h5>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                        <Col lg="12" className=" border-end">
                            <div className="py-3">
                                <div className="top d-flex align-items-center justify-content-between gap-10">
                                    <div className="d-flex align-items-center gap-10">
                                        <div
                                            className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                                            style={{ height: 35, width: 35, background: "rgb(219, 219, 219)" }}
                                        >
                                            {userDetails?.firstname[0]?.toUpperCase() + userDetails?.lastname[0]?.toUpperCase()}
                                        </div>
                                        <div className="content">
                                            <h6 className="m-0 themeBlue fw-sbold">{userFullName(userDetails)}</h6>
                                        </div>
                                        <CommonToolTip
                                            text={"Edit"}
                                            component={
                                                <Button
                                                    className="p-0"
                                                    variant="transparent"
                                                    type="button"
                                                    onClick={() => navigate(generatePath(MANAGE_USERS_EDIT, { id: userDetails?.id }))}
                                                >
                                                    <EditIcon />
                                                </Button>
                                            }
                                        />
                                    </div>
                                    <div className="right">
                                        <div className="d-flex align-items-center gap-10">
                                            <h6 className="m-0 themeBlue fw-bold">Status</h6>
                                            <Form.Select
                                                disabled
                                                style={{ height: "35px" }}
                                                className="form-control"
                                                aria-label="Default select example"
                                                value={statusOptions?.find(x => x.value === userDetails?.status)?.value}
                                            >
                                                {
                                                    statusOptions?.map((item, index) => {
                                                        return <option key={index} value={item.value}>{item?.label}</option>
                                                    })
                                                }
                                            </Form.Select>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="py-3">
                                <Row>
                                    <Col lg="4" md="4" sm="6" className="my-2">
                                        <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                                            <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                                                {" "}
                                                <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                                                    ■
                                                </span>{" "}
                                                Last Name
                                            </h6>
                                            <p className="m-0 forteen themeBlue pt-2">{userDetails?.lastname || "--"}</p>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="4" sm="6" className="my-2">
                                        <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                                            <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                                                {" "}
                                                <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                                                    ■
                                                </span>{" "}
                                                First Name
                                            </h6>
                                            <p className="m-0 forteen themeBlue pt-2">{userDetails?.firstname || "--"}</p>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="4" sm="6" className="my-2">
                                        <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                                            <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                                                {" "}
                                                <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                                                    ■
                                                </span>{" "}
                                                Created At
                                            </h6>
                                            <p className="m-0 forteen themeBlue pt-2">{moment(userDetails?.createdAt).format("DD/MM/YYYY hh:mm A")}</p>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="4" sm="6" className="my-2">
                                        <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                                            <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                                                {" "}
                                                <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                                                    ■
                                                </span>{" "}
                                                Email
                                            </h6>
                                            <p className="m-0 forteen themeBlue pt-2">{userDetails?.email || "--"}</p>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="4" sm="6" className="my-2">
                                        <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                                            <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                                                {" "}
                                                <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                                                    ■
                                                </span>{" "}
                                                Phone
                                            </h6>
                                            <p className="m-0 forteen themeBlue pt-2">{userDetails?.phone || "--"}</p>
                                        </div>
                                    </Col>
                                    <Col lg="4" md="4" sm="6" className="my-2">
                                        <div className="cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                                            <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                                                {" "}
                                                <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                                                    ■
                                                </span>{" "}
                                                Role
                                            </h6>
                                            <p className="m-0 forteen themeBlue pt-2">{userDetails?.client_role?.title || "--"}</p>
                                        </div>
                                    </Col>
                                    <Col lg="2" md="4" sm="6" className="my-2">
                                        <div className="d-flex gap-2 align-items-center cardCstm p-2 bg-white shadow h-100 rounded" style={{ fontSize: 12, lineHeight: "20px" }}>
                                            <p className="m-0 forteen themeBlue pt-2">
                                                <input disabled={isFetching || updateCollaboratorLoading} checked={userDetails?.colloborators_on_notes} onClick={(e) => handleUpdateCollaborator(e)} style={{ height: "20px", width: "20px" }} type="checkbox" />
                                            </p>
                                            <h6 className="m-0 themeBlue fw-bold" style={{ fontSize: 12, lineHeight: "20px" }}>
                                                {/* {" "}
                                                <span className="" style={{ color: "rgb(61, 160, 170)" }}>
                                                    ■
                                                </span>{" "} */}
                                                Collaborator
                                            </h6>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        {console.log(":::::::::::::::::", { userPermissions, selectedPermissions })}
                        <div className=" col-lg-12">
                            <div className="py-2">
                                <div className="row">
                                    <div className="my-2 col-lg-12">
                                        <h5 className="m-0 themeBlue fw-bold">Permissions</h5>
                                        {!userPermissions?.length ? (
                                            <NoRecordFound />
                                        ) : (
                                            <div className="pb-2">
                                                {Object.entries(groupBy(userPermissions, "category_type"))
                                                    .sort(([a], [b]) => {
                                                        if (!a) return 1;
                                                        if (!b) return -1;
                                                        return a.localeCompare(b);
                                                    })
                                                    .map(([category, modules]) => (
                                                        <div key={category} className="my-4 cardCstm p-3 bg-white shadow h-100 rounded">
                                                            {/* Category Title */}
                                                            <h5 className="themeBlue fw-bold text-capitalize mb-3">
                                                                {category}
                                                            </h5>
                                                            <Row>
                                                                {modules.map((item, index) => {
                                                                    return (
                                                                        <Col key={index} md="3" sm="6" className="p-2">
                                                                            <div className="parents-detail-wrapper p-2">
                                                                                <div className="d-flex justify-content-between align-items-center">
                                                                                    <label
                                                                                        htmlFor={`permission_${item.id}`}
                                                                                        style={{ fontSize: "14px", cursor: "pointer" }}
                                                                                        className="m-0 themeBlue fw-bold"
                                                                                    >
                                                                                        {PERMISION_TITLE[item?.module_name] || formatString(item?.module_name)}
                                                                                    </label>
                                                                                    <div className="d-flex align-items-center ps-2">
                                                                                        <input
                                                                                            id={`permission_${item.id}`}
                                                                                            type="checkbox"
                                                                                            className="form-check cursor-pointer"
                                                                                            style={{
                                                                                                height: 15,
                                                                                                width: 15,
                                                                                                marginTop: "-5px",
                                                                                            }}
                                                                                            onChange={(e) =>
                                                                                                handleCheckAll(item, e.target.checked)
                                                                                            }
                                                                                            checked={
                                                                                                selectedPermissions?.find(
                                                                                                    (x) =>
                                                                                                        x?.module_id == item?.id &&
                                                                                                        x?.module_permissions?.length ==
                                                                                                        item?.module_permissions?.length
                                                                                                )
                                                                                                    ? true
                                                                                                    : false
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </Col>
                                                                    );
                                                                })}
                                                            </Row>
                                                        </div>
                                                    )
                                                    )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>
                </Container>}
            </section>
        </>
    );
};

export default ManageUserDetails;
